"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var pieces_1 = require("./pieces");
var state_history_1 = require("state-history");
var constantes_1 = require("./constantes");
var Board = /** @class */ (function () {
    function Board(state) {
        var _this = this;
        if (state === void 0) { state = null; }
        this._isCheck = false;
        this._isCheckMate = false;
        this._isPat = false;
        this._isWin = false;
        this._winner = undefined;
        this._piecesLeft = [0, 0];
        this._mustPromote = null;
        this.onStateChange = function (nextState) {
            console.log('setState');
            _this._mustPromote = null;
            // demap old state positions
            if (_this.state) {
                _this.state.pieces.forEach(function (p) { return (_this.getSquare(p.x, p.y).piece = null); });
            }
            // map new state positions
            _this._piecesLeft[constantes_1.White] = _this._piecesLeft[constantes_1.Black] = 0;
            nextState.pieces.forEach(function (p) {
                _this.getSquare(p.x, p.y).piece = p;
                _this._piecesLeft[p.color]++;
                // si on a un pion sur la derniere ligne, il doit être promu
                if (p.type === pieces_1.Pawn.key && p.y === (p.color === constantes_1.White ? constantes_1.HEIGHT - 1 : 0)) {
                    _this._mustPromote = p;
                }
            });
            _this.state = nextState;
            _this._isWin =
                _this._piecesLeft[constantes_1.White] === 1 || _this._piecesLeft[constantes_1.Black] === 1;
            _this._winner = _this._isWin
                ? _this._piecesLeft[constantes_1.White] === 1
                    ? constantes_1.White
                    : constantes_1.Black
                : undefined;
            _this._isCheck =
                !_this._isWin &&
                    testCheck({
                        whoseKing: _this.state.whoseTurn,
                        pieces: _this.state.pieces,
                    });
            if (!_this._isWin && !_this._mustPromote) {
                _this.invalidatePossibleMoves();
            }
            else {
                _this.possibleMoves = _this.mandatoryMoves = [];
            }
            // TODO maybe dispatch win event
            // TODO maybe dispatch check event
            // TODO maybe dispatch promote event
        };
        var len = constantes_1.WIDTH * constantes_1.HEIGHT;
        var x;
        var y = 0;
        var color;
        this.squares = [];
        for (var i = 0; i < len; i++) {
            x = i % constantes_1.WIDTH;
            x === 0 && i > 0 && y++;
            color = x % 2 === y % 2 ? constantes_1.White : constantes_1.Black;
            this.squares[i] = { x: x, y: y, color: color, piece: null };
        }
        this._history = new state_history_1.StateHistory();
        this._history.subscribe(this.onStateChange);
        if (state) {
            this.setState(state);
        }
    }
    Object.defineProperty(Board.prototype, "isCheck", {
        get: function () {
            return this._isCheck;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Board.prototype, "isCheckMate", {
        get: function () {
            return this._isCheckMate;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Board.prototype, "isPat", {
        get: function () {
            return this._isPat;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Board.prototype, "isWin", {
        get: function () {
            return this._isWin;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Board.prototype, "winner", {
        get: function () {
            return this._winner;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Board.prototype, "mustBePromoted", {
        get: function () {
            return this._mustPromote;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Board.prototype, "history", {
        get: function () {
            return this._history;
        },
        enumerable: true,
        configurable: true
    });
    Board.prototype.setState = function (nextState) {
        this._history.push(nextState);
    };
    Board.prototype.getState = function () {
        return this.state;
    };
    Board.prototype.getPiece = function (x, y) {
        return this.getSquare(x, y).piece;
    };
    Board.prototype.getSquare = function (x, y) {
        if (x < 0 || x >= constantes_1.WIDTH || y < 0 || y >= constantes_1.HEIGHT) {
            return null;
        }
        return this.squares[x + y * constantes_1.WIDTH];
    };
    Board.prototype.move = function (x, y, toX, toY) {
        console.log('move', { x: x, y: y, toX: toX, toY: toY });
        if (this._mustPromote) {
            throw new Error("Can't move because a pawn is awaiting for promotion");
        }
        var piece = this.getPiece(x, y);
        if (!piece) {
            throw new Error("No piece found in " + x + "," + y);
        }
        if (piece.color !== this.state.whoseTurn) {
            throw new Error("The piece found in " + x + "," + y + " does not belong to the current player");
        }
        if (piece.x !== x || piece.y !== y) {
            throw new Error("Piece position {" + piece.x + "," + piece.y + "} differs from {" + x + "," + y + "}. This should never happen: the state has probably been mutated.");
        }
        var legalMoves = this.mandatoryMoves.length
            ? this.mandatoryMoves
            : this.possibleMoves;
        if (!isMoveInList(x, y, toX, toY, legalMoves)) {
            throw new Error('Illegal move');
        }
        // si il y a une piece sur la case d'arrivée, elle est tuée
        var killed = this.getPiece(toX, toY);
        if (killed && killed.type === pieces_1.King.key) {
            throw new Error("King shouldn't get killed");
        }
        var curTurn = this.state.turn || 1;
        this.setState({
            turn: this.state.whoseTurn === constantes_1.Black ? curTurn + 1 : curTurn,
            whoseTurn: this.state.whoseTurn === constantes_1.White ? constantes_1.Black : constantes_1.White,
            pieces: reducePieces(this.state.pieces, piece, __assign({}, piece, { x: toX, y: toY }), killed),
        });
        // TODO maybe dispatch move and kill events
    };
    Board.prototype.promote = function (newType) {
        if (newType === void 0) { newType = pieces_1.Queen; }
        console.log('promote to', newType.key);
        var piece = this._mustPromote;
        if (!piece) {
            throw new Error('No pawn can be promoted right now');
        }
        if (!newType.canPromote) {
            throw new Error('Invalid new piece type for promotion');
        }
        this.setState(__assign({}, this.state, { pieces: reducePieces(this.state.pieces, piece, __assign({}, piece, { type: newType.key })) }));
        // TODO maybe dispatch promoted event
    };
    Board.prototype.getLegalMoves = function () {
        var legalMoves = this.mandatoryMoves.length
            ? this.mandatoryMoves
            : this.possibleMoves;
        // clone moves to be sure user dont mutate them
        return legalMoves.map(function (m) { return (__assign({}, m)); });
    };
    Board.prototype.getLegalMovesFlat = function () {
        return this.mandatoryMoves.length
            ? flatMovesList(this.mandatoryMoves)
            : flatMovesList(this.possibleMoves);
    };
    Board.prototype.invalidatePossibleMoves = function () {
        var _this = this;
        console.log('invalidate possible moves');
        this.possibleMoves = [];
        this.mandatoryMoves = [];
        /**
         * on parcours chaque piece du joueur en cours
         */
        this.state.pieces.forEach(function (piece) {
            if (!piece || piece.color !== _this.state.whoseTurn)
                return;
            var pieceType = pieces_1.getPieceType(piece.type);
            var possibleDest = [];
            var mandatoryDest = [];
            var from = _this.getSquare(piece.x, piece.y);
            /**
             * pour chaque piece on teste tous ses mouvements
             * et on ne retient que les possibles
             */
            pieceType.movements.forEach(function (movement) {
                return findPossibleDestinations(piece, movement, from, _this.getSquare.bind(_this), function (hypothetic) {
                    /**
                     * test if the king will be checked after this move
                     */
                    var willCheck = testCheck({
                        whoseKing: _this.state.whoseTurn,
                        pieces: reducePieces(_this.state.pieces, piece, __assign({}, piece, { x: hypothetic.x, y: hypothetic.y }), hypothetic.piece),
                    });
                    if (hypothetic.piece) {
                        // case occupée par un ennemi, mouvement obligatoire
                        // sauf si :
                        // - aller ici nous mettrait en échec
                        // - la piece sur la case ciblée est le roi ennemi
                        // (permet d'empecher de tuer le roi noir dès le premier
                        // tour si il se trouvait en échec à cause des placements initiaux)
                        if (!willCheck && hypothetic.piece.type !== pieces_1.King.key) {
                            mandatoryDest.push(hypothetic);
                        }
                        return;
                    }
                    // case libre
                    if (!willCheck)
                        possibleDest.push(hypothetic);
                });
            });
            if (mandatoryDest.length) {
                // si cette pièce a des mouvements obligatoires, on les enregistre
                _this.mandatoryMoves.push({
                    from: from,
                    to: mandatoryDest,
                });
            }
            else if (possibleDest.length) {
                // si elle n'a pas de mouvement obligatoire, on enregistre les mouvements possibles
                _this.possibleMoves.push({
                    from: from,
                    to: possibleDest,
                });
            }
        });
        var noLegalMove = this.mandatoryMoves.length === 0 && this.possibleMoves.length === 0;
        this._isCheckMate = noLegalMove && this._isCheck;
        this._isPat = noLegalMove && !this._isCheck;
        // TODO maybe dispatch an event if checkMate or pat
    };
    Board.prototype.destroy = function () {
        this._history.unsubscribe(this.onStateChange);
    };
    return Board;
}());
exports.default = Board;
function isMoveInList(x, y, toX, toY, list) {
    return list.some(function (moves) {
        if (moves.from.x === x && moves.from.y === y) {
            return moves.to.some(function (dest) {
                return dest.x === toX && dest.y === toY;
            });
        }
        return false;
    });
}
function flatMovesList(list) {
    var out = [];
    list.forEach(function (moves) {
        moves.to.forEach(function (dest) {
            return out.push({ x: moves.from.x, y: moves.from.y, toX: dest.x, toY: dest.y });
        });
    });
    return out;
}
/**
 * retourne une copie du tableau `pieces`
 * en remplaçant `piece` par `newState`
 * et en supprimant `remove` de la liste
 * @param pieces
 * @param piece
 * @param newState
 * @param remove
 */
function reducePieces(pieces, piece, newState, remove) {
    if (remove === void 0) { remove = null; }
    return pieces.reduce(function (acc, p) {
        if (p === piece) {
            // si c'est la piece dont il faut modifier la position
            acc.push(newState);
        }
        else if (p !== remove) {
            // on retire de la liste la piece tuée
            acc.push(p);
        }
        return acc;
    }, []);
}
/**
 * used to create a virtual board for check test
 * @param squares
 * @param x
 * @param y
 */
function getOrCreateSquare(squares, x, y) {
    if (x < 0 || x >= constantes_1.WIDTH || y < 0 || y >= constantes_1.HEIGHT) {
        return null;
    }
    return (squares[x + y * constantes_1.WIDTH] ||
        (squares[x + y * constantes_1.WIDTH] = {
            x: x,
            y: y,
            piece: null,
            color: null,
        }));
}
/**
 * test if the king can be killed by an opponent
 * @param state
 */
function testCheck(state) {
    var squares = [];
    var whoseKing = state.whoseKing, pieces = state.pieces;
    var getSquare = function (x, y) { return getOrCreateSquare(squares, x, y); };
    var what = pieces
        .filter(function (piece, i) {
        getOrCreateSquare(squares, piece.x, piece.y).piece = piece;
        return piece.color !== whoseKing;
    })
        .some(function (piece) {
        // apply piece movements
        var pieceType = pieces_1.getPieceType(piece.type);
        var from = getOrCreateSquare(squares, piece.x, piece.y);
        return pieceType.movements.some(function (movement) {
            return findPossibleDestinations(piece, movement, from, getSquare, function (hypothetic) {
                if (hypothetic.piece &&
                    hypothetic.piece.type === pieces_1.King.key &&
                    hypothetic.piece.color === whoseKing) {
                    return true;
                }
            });
        });
    });
    return what;
}
exports.testCheck = testCheck;
/**
 * appelle `callback` sur chaque case où ce mouvement permet d'aller
 *
 * si `callback` retourne autre chose que `undefined`,
 * cette fonction s'arrête de tenter de répeter le mouvement et retourne
 * la valeur retournée par `callback`
 *
 * @param piece
 * @param movement
 * @param from
 * @param getSquare
 * @param callback
 */
function findPossibleDestinations(piece, movement, from, getSquare, callback) {
    // multiplicateur des mouvements selon le côté du joueur
    // 1 pour le joueur du bas (blanc) et -1 pour le joueur du haut (noir)
    var sideMult = piece.color === constantes_1.White ? 1 : -1;
    var repeat = 0;
    var hypothetic = from;
    var x;
    var y;
    // tant que le mouvement peut être répété
    while (repeat < movement.repeat) {
        x = hypothetic.x + movement.x * sideMult;
        y = hypothetic.y + movement.y * sideMult;
        hypothetic = getSquare(x, y);
        if (
        // si la case existe
        hypothetic &&
            // et qu'elle est vide ou occupée par un ennemi
            (hypothetic.piece === null || hypothetic.piece.color !== piece.color) &&
            // et que la condition du movement est remplie
            (movement.condition === null ||
                movement.condition(from, hypothetic, repeat, getSquare))) {
            var r = callback(hypothetic);
            if (r !== undefined)
                return r;
            if (hypothetic.piece) {
                // si case occupée, on quitte car on ne pourra pas aller plus loin
                return;
            }
            // la case est libre, on repete pour trouver des cases libres plus loin
            repeat++;
        }
        else {
            // si la case n'existe pas
            // ou est occupée par un allié
            // ou la condition du mouvement ne permet pas d'y aller
            return;
        }
    }
}



/*****************
 ** WEBPACK FOOTER
 ** ../brchess-core/dist/Board.js
 ** module id = 4
 ** module chunks = 0
 **/